module.exports = __webpack_public_path__ + "zarustajici-nehty_2_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/zarustajici-nehty_2_before_tn.jpg
// module id = 1508
// module chunks = 0